var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatingPassIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3881 9L17.4698 3.91832C18.0934 3.29473 18.0934 2.28367 17.4698 1.65957L16.3404 0.530195C15.7168 -0.0933985 14.7058 -0.0933985 14.0817 0.530195L9 5.61188L3.91832 0.530195C3.29473 -0.0933985 2.28367 -0.0933985 1.65957 0.530195L0.530195 1.65957C-0.0933985 2.28316 -0.0933985 3.29422 0.530195 3.91832L5.61188 9L0.530195 14.0817C-0.0933985 14.7053 -0.0933985 15.7163 0.530195 16.3404L1.65957 17.4698C2.28316 18.0934 3.29473 18.0934 3.91832 17.4698L9 12.3881L14.0817 17.4698C14.7053 18.0934 15.7168 18.0934 16.3404 17.4698L17.4698 16.3404C18.0934 15.7168 18.0934 14.7058 17.4698 14.0817L12.3881 9Z",
    fill: "url(#paint0_linear_10496_10911)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10496_10911",
    x1: 9,
    y1: 0.0625,
    x2: 9,
    y2: 17.9375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF1800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1800",
    stopOpacity: 0.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatingPassIcon);
export default __webpack_public_path__ + "static/media/dating-pass-icon.9eaa5991f6b0dc82082a02dac778843d.svg";
export { ForwardRef as ReactComponent };